import React, { useState, useEffect } from "react";
import { Table, Card, Badge } from "react-bootstrap";
import { FaBook } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// Countdown Timer केवल emi_end_date के लिए
function CountdownTimer({ emiEndDate }) {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    if (!emiEndDate) return;

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const end = new Date(emiEndDate).getTime();
      const distance = end - now;

      if (distance <= 0) {
        clearInterval(interval);
        setTimeLeft("Expired");
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    }, 1000);

    return () => clearInterval(interval);
  }, [emiEndDate]);

  return <span style={{ color: "red", fontWeight: "bold" }}>{timeLeft}</span>;
}

function CourseList() {
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("user_id");
  const [planlist, setplanList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    planpackagelist();
  }, []);

  const planpackagelist = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/plan-package-list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id: user_id }),
        }
      );

      if (!res.ok) throw new Error("Failed to fetch plan");

      const data = await res.json();
      setplanList(data.data || []);
    } catch (err) {
      console.error("Error fetching plan:", err);
    }
  };

  const getStatusBadge = (
    status,
    emi_status,
    package_id,
    course_id,
    package_plan_id,
    emi_end_date,
    payment_status
  ) => {
    // EMI Expired check लेकिन केवल तभी जब complet_pay ना हो
    if (emi_end_date && payment_status !== "complet_pay") {
      const now = new Date().getTime();
      const emiEnd = new Date(emi_end_date).getTime();

      if (emiEnd <= now) {
        // EMI time finished → show continue payment button
        return (
          <Badge
            bg="warning"
            className="w-100"
            style={{ cursor: "pointer" }}
            onClick={() => {
              localStorage.setItem("courseId", course_id);
              localStorage.setItem("packageId", package_id);
              localStorage.setItem("plan_id", package_plan_id);
              navigate("/course-cart"); // Navigate to continue payment page
            }}
          >
            Continue Payment
          </Badge>
        );
      }
    }

    // Expired check
    if (
      status?.toLowerCase() === "expired" ||
      emi_status?.toLowerCase() === "expired"
    ) {
      return (
        <Badge bg="danger" className="w-100">
          Expired
        </Badge>
      );
    }

    // Active check (both active)
    if (
      status?.toLowerCase() === "active" &&
      emi_status?.toLowerCase() === "active"
    ) {
      return (
        <Badge
          bg="success"
          className="w-100"
          style={{ cursor: "pointer" }}
          onClick={() => {
            localStorage.setItem("packageId", package_id);
            localStorage.setItem("package_plan_id", package_plan_id);
            navigate("/course-detail-subject");
          }}
        >
          Course Content →
        </Badge>
      );
    }

    // Other badges
    switch (status?.toLowerCase()) {
      case "paid":
        return (
          <Badge bg="success" className="w-100">
            Paid
          </Badge>
        );
      case "pending":
        return (
          <Badge bg="warning" className="w-100" text="dark">
            Pending
          </Badge>
        );
      case "overdue":
        return (
          <Badge bg="danger" className="w-100">
            Overdue
          </Badge>
        );
      case "inactive":
        return (
          <Badge bg="primary" className="w-100">
            Pursuing
          </Badge>
        );
      default:
        return (
          <Badge bg="secondary" className="w-100">
            {status}
          </Badge>
        );
    }
  };

  // Payment status readable name
  const formatPaymentStatus = (status) => {
    switch (status) {
      case "complet_pay":
        return "Complete Pay";
      case "installment_pay":
        return "Installment Pay";
      default:
        return status;
    }
  };

  // Function to show end date or countdown
  const renderEndDate = (item) => {
    const endDate =
      item.payment_status === "complet_pay" ? item.end_date : item.emi_end_date;

    if (!endDate) return "-";

    if (item.payment_status !== "complet_pay") {
      const daysLeft = Math.floor(
        (new Date(endDate) - new Date()) / (1000 * 60 * 60 * 24)
      );
      if (daysLeft <= 5) {
        return <CountdownTimer endDate={endDate} />;
      }
    }

    return endDate;
  };

  return (
    <Card className="shadow border-0">
      <Card.Header className="bg-primary text-white">
        <FaBook className="me-2" />
        My Course
      </Card.Header>
      <Card.Body>
        <Table striped bordered hover responsive>
          <thead className="table-success">
            <tr>
              <th>Course ID</th>
              <th>Course Name</th>
              <th>Package Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Amount</th>
              <th>Pay Status</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {planlist.length > 0 ? (
              planlist.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.course_name}</td>
                  <td>{item.package_name}</td>
                  <td>
                    {item.payment_status === "complet_pay"
                      ? item.start_date
                      : item.emi_start_date || "-"}
                  </td>
                  <td>
                    {item.payment_status !== "complet_pay" &&
                    item.emi_end_date ? (
                      // अगर emi_end_date में 5 दिन या कम बचे हैं
                      new Date(item.emi_end_date) - new Date() <=
                      5 * 24 * 60 * 60 * 1000 ? (
                        <CountdownTimer emiEndDate={item.emi_end_date} />
                      ) : (
                        item.emi_end_date
                      )
                    ) : (
                      item.end_date
                    )}
                  </td>
                  <td>
                    <strong>{item.amount}</strong>
                  </td>
                  <td>
                    <strong>{formatPaymentStatus(item.payment_status)}</strong>
                  </td>
                  <td>
                    {getStatusBadge(
                      item.status,
                      item.emi_status,
                      item.package_id,
                      item.course_id,
                      item.package_plan_id,
                      item.emi_end_date,
                      item.payment_status
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">
                  <div className="text-center py-4">
                    <p>No package plans available</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default CourseList;
